import { Injectable } from '@angular/core';
import { Day } from '@app/utils/models/itinerary/day.model';
import { Experience } from '@app/utils/models/itinerary/experience.model';
import { map, Observable, shareReplay } from 'rxjs';
import { ExperienceType } from '@ess-front/shared';
import { CityAccommodations } from '@app/utils/models/itinerary/city-accommodations';

@Injectable({
  providedIn: 'root',
})
export class ItinerarySelectorsService {
  getAccommodationsByCity$(days$: Observable<readonly Day[]>): Observable<readonly CityAccommodations[]> {
    return days$.pipe(
      map(days => this.getDaysAccommodations(days)),
      map(accomodations =>
        accomodations.reduce((acc: { accommodations: Experience[]; city: string }[], accommodation: Experience) => {
          const group = acc.find(group => group.city === accommodation.city);
          if (group) {
            group.accommodations.push(accommodation);
          } else {
            acc.push({ city: accommodation.city ?? '', accommodations: [accommodation] });
          }
          return acc;
        }, []),
      ),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  private getDaysAccommodations(days: readonly Day[]): Experience[] {
    return days.flatMap(day => day.experiences.filter(experience => experience.type === ExperienceType.ACCOMMODATION));
  }
}
